import type { PartnerAccount } from "@stockline/shared/types/crm/partner-account"
import type { OfflineResourceConfig } from "../../../types"
import { PARTNER_ACCOUNT_TABLE } from "./db"

export const partnerAccountConfig: OfflineResourceConfig<PartnerAccount> = {
  name: "partner-accounts",
  syncDisabled: false,
  endpoints: {
    full: "/api/v2/partner-accounts",
    delta: "/api/v2/partner-accounts/changes",
    push: "/api/v2/partner-accounts/changes",
  },
  tableName: PARTNER_ACCOUNT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    partnerId: "partnerId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
